import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface CloverState {
  merchant_id: string | null;
  employee_id: string | null;
  client_id: string | null;
  code: string | null;
  restaurantId: string | null;
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: CloverState = {
  merchant_id: null,
  employee_id: null,
  client_id: null,
  code: null,
  restaurantId: "4bebbb8a-a2bf-4d53-b287-842c3c5be847",
  loading: false,
  error: null,
  success: false,
};

const cloverSlice = createSlice({
  name: 'clover',
  initialState,
  reducers: {
    // Initiate Clover OAuth redirect
    initiateCloverAuth: (state) => {
      state.loading = true;
      state.error = null;
    },
    // Hydrate state from localStorage on app init
    hydrateCloverState: (
      state,
      action: PayloadAction<{
        merchant_id: string | null;
        employee_id: string | null;
        client_id: string | null;
        code: string | null;
        restaurantId: string | null;
      }>
    ) => {
      state.merchant_id = action.payload.merchant_id;
      state.employee_id = action.payload.employee_id;
      state.client_id = action.payload.client_id;
      state.code = action.payload.code;
      state.restaurantId = action.payload.restaurantId;
    },
    integrateCloverRequest: (
      state,
      action: PayloadAction<{
        merchant_id: string;
        employee_id: string;
        client_id: string;
        code: string;
      }>
    ) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.merchant_id = action.payload.merchant_id;
      state.employee_id = action.payload.employee_id;
      state.client_id = action.payload.client_id;
      state.code = action.payload.code;
    },
    integrateCloverSuccess: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.restaurantId = action.payload;
    },
    integrateCloverFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCloverState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  initiateCloverAuth,
  hydrateCloverState,
  integrateCloverRequest,
  integrateCloverSuccess,
  integrateCloverFailure,
  resetCloverState,
} = cloverSlice.actions;

// Selectors
export const selectRestaurantId = (state: { clover: CloverState }) => state.clover.restaurantId;

export default cloverSlice.reducer;
